import logPage, {
  LogPageState,
} from 'containers/LogPage/store/reducers/logPage.reducer';
import { connect, ConnectedProps } from 'react-redux';
import * as fromDucks from 'containers/LogPage/store/ducks/logPage.ducks';

export const logPageReducer = logPage;
export const connector = connect((state: LogPageState) => ({ state }), fromDucks);
export type PropsFromRedux = ConnectedProps<typeof connector>;
